import React, { useState, useEffect } from 'react';
import { CategoryService, LocalStorageService } from '../../../services';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultSubcategoriesView } from '../../views';

function DigitalVaultSubcategoriesAction(props) {
    const {
        toggleErrorRequesting,
        breadcrumbItems,
        handleBreadcrumbClick,
        subcategoryPath,
        setSubcategoryPath,
        selectedCompany,
        selectedCategory,
        setSelectedDocument,
    } = props;

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const categoryService = new CategoryService(url);
    const token = localStorageService.getLocalStorageItem("token").idToken;

    const [isLoading, setIsLoading] = useState(true);
    const [gridIsLoading, setGridIsLoading] = useState(false);

    const [subcategoryTree, setSubcategoryTree] = useState([]);
    const [currentSubcategory, setCurrentSubcategory] = useState(null);
    const [subcategoryData, setSubcategoryData] = useState([]);

    const loadSubcategoryTree = async () => {
        setIsLoading(true);

        try {
            let categoryHasSpecialPermission = (selectedCategory.hasSpecialPermission) ? true : false
            const response = await categoryService.getSubcategories(token, selectedCompany.company.id, selectedCategory.id, categoryHasSpecialPermission);
            if (response.statusCode == 200 && response.data) {
                setSubcategoryTree(response.data);
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo las subcategorías.")
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const loadSubcategory = async () => {
        setGridIsLoading(true);

        try {
            let hasSpecialPermission = (currentSubcategory.subcategory.hasSpecialPermission) ? true : false
            const response = await categoryService.getSubcategoryDocuments(token, selectedCompany.company.id, currentSubcategory.subcategory.id, hasSpecialPermission);
            if (response.statusCode == 200 && response.data) {
                setSubcategoryData(response.data);
            } else {
                throw new Error(response.data.message || "Ocurrió un error obteniendo la subcategoría.")
            }
            setGridIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    useEffect(() => {
        if (!currentSubcategory) {
            setSubcategoryData([])
        } else {
            loadSubcategory();
        }
    }, [currentSubcategory])

    useEffect(() => {
        loadSubcategoryTree();
    }, [])

    return (
        <DigitalVaultSubcategoriesView
            {...props}
            isLoading={isLoading}
            gridIsLoading={gridIsLoading}
            breadcrumbItems={breadcrumbItems}
            handleBreadcrumbClick={handleBreadcrumbClick}

            selectedCategory={selectedCategory}

            subcategoryTree={subcategoryTree}
            currentSubcategory={currentSubcategory}
            setCurrentSubcategory={setCurrentSubcategory}
            subcategoryData={subcategoryData}

            subcategoryPath={subcategoryPath}
            setSubcategoryPath={setSubcategoryPath}
            setSelectedDocument={setSelectedDocument}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultSubcategoriesAction));